<template>
	<div v-loading="pageloading">
		<el-form :model="form" ref="ruform" label-width="150px" :rules="rules" style="margin-bottom:100px">
			<el-card>
				<template slot="header">推手招募</template>
				<el-form-item label="加入条件：" required>
					<el-radio-group v-model="form.IsHavethreshold" class="flex" style="margin-top:10px">
						<div class="flex fle-align-center margin-right-20">
							<el-radio :label="0" style="margin-right:10px">有门槛授权（或）</el-radio>
							<el-popover placement="bottom-end" trigger="hover">
								<div style="width:200px">
									有门槛授权，支持选择多个条件，多个条件间关系为“或”，即完成任一条件即可成为推手
								</div>
								<div slot="reference" class="font-14 color-606266"><i
										class="el-icon-warning-outline"></i> </div>
							</el-popover>
						</div>
						<el-radio :label="1">无门槛授权</el-radio>
					</el-radio-group>
					<div v-if="form.IsHavethreshold == 0" style="margin-top:10px">
						<el-checkbox-group v-model="form.DriverAuthThresholdTypes">
							<div class="secgray-box">
								<el-form-item label="" prop="TotalCompleteTradeMoney" class="error-font-money"
									:rules="form.DriverAuthThresholdTypes.includes(1) ? rules.TotalCompleteTradeMoney : rules.nocheck">
									<div class="flex flex-align-center">
										<el-checkbox :label="1" style="margin:0px">累计完成交易</el-checkbox>
										<el-input style="width:100px;margin:0px 10px"
											v-model.trim="form.TotalCompleteTradeMoney"
											onkeyup="value=value.replace(/[^0-9.]/g,'')"
											oninput="value=value.replace(/[^0-9.]/g,'')"
											:disabled="!form.DriverAuthThresholdTypes.includes(1)"></el-input>
										<span style="color:#606266FF">元</span>
									</div>
									<div class="grayfont-12" style="margin:5px 0px 0px 25px">
										客户确认收货成功即计入完成交易金额；订单确认收货前退款成功的金额不计入在内</div>
								</el-form-item>
								<div style="margin-top:20px">
									<el-checkbox :label="0" style="margin:0px">购买授权礼包商品</el-checkbox>
									<div class="flex flex-align-center">
										<div class="grayfont-12" style="margin-left:25px">
											成功购买授权礼包商品后，自动授权成为推手。授权礼包商品请前往商品列表管理</div>
										<el-button type="text" style="margin:0px 20px;padding:0px;font-size:12px"
											@click="toshoplist">前往商品列表</el-button>
										<el-link
											href="https://jusnn6k8al.feishu.cn/docx/Ky7ydoZWzos9abxP45XcZKzfnWA?from=from_copylink"
											:underline="false" type="primary" target="_blank"
											style="line-height:1;font-size:12px">查看操作说明</el-link>
									</div>
								</div>
								<el-form-item label="" prop="BalanceSingleRechargeMoney" class="error-font-money"
									style="margin-top:20px"
									:rules="form.DriverAuthThresholdTypes.includes(3) ? rules.BalanceSingleRechargeMoney : rules.nocheck">
									<div class="flex flex-align-center">
										<el-checkbox :label="3" style="margin:0px">余额单笔充值</el-checkbox>
										<el-input style="width:100px;margin:0px 10px"
											v-model.trim="form.BalanceSingleRechargeMoney"
											onkeyup="value=value.replace(/[^0-9.]/g,'')"
											oninput="value=value.replace(/[^0-9.]/g,'')"
											:disabled="!form.DriverAuthThresholdTypes.includes(3)"></el-input>
										<span style="color:#606266FF">元</span>
									</div>
									<div class="flex flex-align-center">
										<div class="grayfont-12" style="margin:5px 0px 0px 25px">余额单笔充值达到门槛后，自动授权成为推手。
										</div>
										<el-button type="text" style="margin:0px 20px;padding:0px;font-size:12px"
											@click="torules">前往配置余额储值规则</el-button>
									</div>
								</el-form-item>
							</div>
						</el-checkbox-group>
					</div>
					<div class="grayfont-12" v-else>
						客户进入推手招募页，绑定手机号即可授权成为推手
					</div>
				</el-form-item>
				<el-form-item label="推手招募页：" required style="margin-top:50px">
					<el-radio-group v-model="form.DriverRecruitmentPageTemplateType">
						<el-radio :label="0">使用系统模板</el-radio>
						<el-radio :label="1">自定义页面</el-radio>
					</el-radio-group>
				</el-form-item>
				<div v-show="form.DriverRecruitmentPageTemplateType == 0" style="padding-left:150px;margin-bottom: 20px;">
					<pagemode :config="form.Config"></pagemode>
				</div>
				<div v-show="form.DriverRecruitmentPageTemplateType == 1">
					<div class="flex flex-align-center" style="margin-bottom:20px">
						<div class="label-font">页面标题</div>
						<el-input v-model="form.Config.title" style="width:375px" maxlength="20"
							placeholder="若为空，默认为：推手招募"></el-input>
					</div>
					<div class="flex flex-align-center" style="margin-bottom:20px">
						<div class="label-font">邀请语</div>
						<el-input v-model="form.Config.welcome" style="width:375px" maxlength="20"
							:placeholder="'若为空，默认为：邀请你一起加入' + mallInfo.PcMallName"></el-input>
					</div>
					<div class="flex" style="margin-bottom:20px">
						<div class="label-font">邀请内容</div>
						<quill-editor ref="welcomecontent" v-model="form.Config.customContent" :options="quillOption"
							style="margin:0px 0px 100px 0px;width:375px;height: 1000px;">
						</quill-editor>
					</div>
				</div>
				<el-form-item label="立即成为推手按钮：">
					<el-input placeholder="立即成为推手" v-model="form.DriverRecruitmentPageBeDriverText " style="width: 200px;"></el-input>
					<div style="font-size: 12px;color: #999999;line-height: 16px;margin-top: 8px;">
						默认按钮文案：立即成为推手；可自定义按钮文案，文案为空，将使用默认文案；最多6个字
						<span style="color: #409EFF;cursor: pointer;padding-left: 5px;" @click="showExample=true">查看示例</span>
					</div>
				</el-form-item>
				<el-form-item label="推广商品按钮：">
					<el-radio-group v-model="form.DriverRecruitmentPageIsShowPromoteProductButton">
						<el-radio :label="true">显示</el-radio>
						<el-radio :label="false">不显示</el-radio>
					</el-radio-group>
					<div v-if="form.DriverRecruitmentPageIsShowPromoteProductButton">
						<el-input placeholder="推广商品" v-model="form.DriverRecruitmentPagePromoteProductText" style="width: 200px;"></el-input>
					</div>
					<div v-if="form.DriverRecruitmentPageIsShowPromoteProductButton" style="font-size: 12px;color: #999999;line-height: 16px;margin-top: 8px;">
						默认按钮文案：推广商品；可自定义按钮文案，文案为空，将使用默认文案；最多4个字
						<span style="color: #409EFF;cursor: pointer;padding-left: 5px;" @click="showExample=true">查看示例</span>
					</div>
				</el-form-item>
				<el-form-item label="点击按钮跳转至：" v-if="form.DriverRecruitmentPageIsShowPromoteProductButton">
					<el-radio-group v-model="recommendBtnLink.type">
						<el-radio :label="0">推广商品列表页</el-radio>
						<el-radio :label="1">
							<span style="vertical-align: middle;" @click="handleShowLinkPop(1)">
								<span class="ellipsis-one" v-if="recommendBtnLink.config && recommendBtnLink.config.text">
									{{ recommendBtnLink.config.text }}
								</span>
								<span v-else>自定义选择页面</span>
								<i class="el-icon-close" v-if="recommendBtnLink.config && recommendBtnLink.config.text" @click.stop="recommendBtnLink.config=''"></i>
								<i class="el-icon-arrow-down"></i>
							</span>
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="邀请好友按钮：">
					<el-radio-group v-model="form.DriverRecruitmentPageIsShowInviteFriendButton">
						<el-radio :label="true">显示</el-radio>
						<el-radio :label="false">不显示</el-radio>
					</el-radio-group>
					<div v-if="form.DriverRecruitmentPageIsShowInviteFriendButton">
						<el-input placeholder="邀请好友" v-model="form.DriverRecruitmentPageInviteFriendText" style="width: 200px;"></el-input>
					</div>
					<div v-if="form.DriverRecruitmentPageIsShowInviteFriendButton" style="font-size: 12px;color: #999999;line-height: 16px;margin-top: 8px;">
						默认按钮文案：邀请好友；可自定义按钮文案，文案为空，将使用默认文案；最多4个字
						<span style="color: #409EFF;cursor: pointer;padding-left: 5px;" @click="showExample=true">查看示例</span>
					</div>
				</el-form-item>
				<el-form-item label="点击按钮跳转至：" v-if="form.DriverRecruitmentPageIsShowInviteFriendButton">
					<el-radio-group v-model="invateFriendLink.type">
						<el-radio :label="0">邀请好友页</el-radio>
						<el-radio :label="1">
							<span style="vertical-align: middle;" @click="handleShowLinkPop(2)">
								<span class="ellipsis-one" v-if="invateFriendLink.config && invateFriendLink.config.text">
									{{ invateFriendLink.config.text }}
								</span>
								<span v-else>自定义选择页面</span>
								<i class="el-icon-close" v-if="invateFriendLink.config && invateFriendLink.config.text" @click.stop="invateFriendLink.config=''"></i>
								<i class="el-icon-arrow-down"></i>
							</span>
						</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-card>
		</el-form>
		<el-card class="bottom-banner">
			<div style="margin-left:8%"></div>
			<el-button type="primary" @click="save('ruform')">保存</el-button>
			<el-button type="primary" style="background:#fff;color:#409eff" plain
				@click="promoteShow = true">招募推广</el-button>
		</el-card>
		<!-- //推广 -->
		<promote :visible="promoteShow" :data="form" @close="closepromote"></promote>

		 <link-modal :showLiveTab="true" :visible="linkVisible" @change="dataChange" @cancel="linkVisible=false"></link-modal>

		<el-dialog :visible.sync="showExample" title="查看示例" width="600px">
			<div>
				<img src="https://cdn.dkycn.cn/images/melyshop/2025081213520005.jpg" style="width: 530px;height: 537px;display: block;margin: 0 auto;">
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import quillConfig from '@/components/quill-config-nolink.js'
	import pagemode from '@/views/distribution/driverrecruiting/components/pagemode.vue'
	import promote from '@/views/distribution/driverrecruiting/components/promote.vue';
	import linkModal from '@/views/components/linkModal';
	import {
		malldriverRecruitmentConfig,
		malldriverRecruitmentConfigSave
	} from '@/api/sv3.0.0'
	export default {
		components: {
			pagemode,
			promote,
			linkModal
		},
		computed: {
			...mapGetters([
				'mallInfo'
			]),
		},
		data() {
			var checkTotalCompleteTradeMoney = (rule, value, callback) => {
				if (this.form.IsHavethreshold == 0 && this.form.DriverAuthThresholdTypes.includes(1)) {
					let two = /^\d+(\.\d{1,2})?$/
					if (value < 0.01 || value > 99999 || !two.test(value)) {
						callback(new Error('金额请输入0.01~99999元之间，最多2位小数'))
					} else {
						callback()
					}
				} else {
					callback()
				}
			};
			var checkBalanceSingleRechargeMoney = (rule, value, callback) => {
				if (this.form.IsHavethreshold == 0 && this.form.DriverAuthThresholdTypes.includes(3)) {
					let two = /^\d+(\.\d{1,2})?$/
					if (value < 0.01 || value > 20000 || !two.test(value)) {
						callback(new Error('金额请输入0.01~20000元之间，最多2位小数'))
					} else {
						callback()
					}
				} else {
					callback()
				}
			};
			var nocheck = (rule, value, callback) => {
				callback()
			}
			return {
				showExample: false,
				pageloading: false,
				form: {
					IsHavethreshold: 0,//有无门槛
					DriverAuthThresholdTypes: [],//有门槛的类型
					DriverRecruitmentPageTemplateType: 0,
					Config: {},
					DriverRecruitmentPageShareCardImgUrl: '',
					DriverRecruitmentPageShareDescription: '',
					TotalCompleteTradeMoney: '',
					BalanceSingleRechargeMoney: '',
					DriverRecruitmentPageBeDriverText: '',
					DriverRecruitmentPageIsShowPromoteProductButton: true,
					DriverRecruitmentPagePromoteProductJumpConfig: '',
					DriverRecruitmentPagePromoteProductText: '',
					DriverRecruitmentPageIsShowInviteFriendButton: true,
					DriverRecruitmentPageInviteFriendText: ''

				},
				rules: {
					TotalCompleteTradeMoney: [
						{ validator: checkTotalCompleteTradeMoney, trigger: 'blur' }
					],
					BalanceSingleRechargeMoney: [
						{ validator: checkBalanceSingleRechargeMoney, trigger: 'blur' }
					],
					nocheck: [
						{ require: false, validator: nocheck, }
					]
				},
				quillOption: quillConfig,
				promoteShow: false,
				linkVisible: false,
				recommendBtnLink: {
					type: 0,
					config: ''
				},
				invateFriendLink: {
					type: 0,
					config: ''
				}
			}
		},
		mounted() {
			this.getinfo()
		},
		methods: {
			handleShowLinkPop(type){
				this.linkType = type;
				this.linkVisible = true;
			},
			dataChange(record){
				if (this.linkType === 1){
					this.recommendBtnLink.config = record;
				}else if (this.linkType === 2){
					this.invateFriendLink.config = record;
				}
			},
			closepromote(val, refresh) {
				this.promoteShow = val
				if (refresh) {
					this.getinfo()
				}
			},
			async getinfo() {
				try {
					this.pageloading = true
					let res = await malldriverRecruitmentConfig()
					if (res.IsSuccess) {
						let form = res.Result
						//DriverAuthThresholdTypes  购买授权礼包授权 = 0,累计完成交易 = 1,无门槛授权 = 2  单笔充值 = 3
						if (JSON.stringify(form.DriverAuthThresholdTypes) == JSON.stringify([2])) {
							form.IsHavethreshold = 1
							form.TotalCompleteTradeMoney = ''
							form.BalanceSingleRechargeMoney = ''
						} else {
							form.IsHavethreshold = 0
						}
						// this.form.DriverRecruitmentPageTemplateType = form.DriverRecruitmentPageTemplateType
						let config = {
							title: '推手招募',//页面标题
							welcome: '邀请你一起加入' + this.mallInfo.PcMallName,//邀请语
							bgImage: '/image/pagemode-bg.png',//背景图
							mainTitle: '推手招募令',//主标题
							subtitle: '欢迎加入我们，自购省钱，分享赚钱',//副标题
							lightColor: '#C0391F',//浅色
							darkColor: '#8C1E09',//深色
							list: [
								{
									title: '如何成为推手？',
									content: '达到授权门槛后，点击下方【立即成为推手】按钮，注册成为推手'
								},
								{
									title: '推手如何获得收益？',
									content: '1.成为推手后，分享商品或商城其他页面给微信好友，或者点击页面内的【赚】字，生成分享海报至微信朋友圈\n2.好友通过你分享的链接进入商城成交，你可获得收益\n3.好友确认收货后，系统自动结算收益，你可提现已结算的收益'
								},
								{
									title: '推手收益说明',
									content: '1.好友通过你分享的链接进入商城成交，你可获得推手收益\n2.订单确认收货前，退款成功的部分，相应的收益将会扣除\n3.订单确认收货后，可提现收益'
								},
							],
							customContent: ''//自定义内容
						}
						form.Config = form.DriverRecruitmentPageConfig ? JSON.parse(form.DriverRecruitmentPageConfig) : config

						try {
							if (form.DriverRecruitmentPagePromoteProductJumpConfig){
								this.recommendBtnLink = JSON.parse(form.DriverRecruitmentPagePromoteProductJumpConfig)
							}
							if (form.DriverRecruitmentPageInviteFriendJumpConfig){
								this.invateFriendLink = JSON.parse(form.DriverRecruitmentPageInviteFriendJumpConfig)
							}
						} catch (error) {
							console.log(error)
						}
						

						this.form = form
						// console.log(this.form)
					}
				} finally {
					this.pageloading = false
				}
			},
			async submit() {
				let form = JSON.parse(JSON.stringify(this.form))
				if (form.IsHavethreshold == 1) {
					form.DriverAuthThresholdTypes = [2]
					form.TotalCompleteTradeMoney = ''
					form.BalanceSingleRechargeMoney = ''
				} else {
					form.DriverAuthThresholdTypes = form.DriverAuthThresholdTypes.filter(v => v != 2)
				}
				if (!form.DriverAuthThresholdTypes || !form.DriverAuthThresholdTypes.length) {
					this.$message.error('请设置加入条件')
					return
				}
				let list = [
					{
						title: '如何成为推手？',
						content: '达到授权门槛后，点击下方【立即成为推手】按钮，注册成为推手'
					},
					{
						title: '推手如何获得收益？',
						content: '1.成为推手后，分享商品或商城其他页面给微信好友，或者点击页面内的【赚】字，生成分享海报至微信朋友圈\n2.好友通过你分享的链接进入商城成交，你可获得收益\n3.好友确认收货后，系统自动结算收益，你可提现已结算的收益'
					},
					{
						title: '推手收益说明',
						content: '1.好友通过你分享的链接进入商城成交，你可获得推手收益\n2.订单确认收货前，退款成功的部分，相应的收益将会扣除\n3.订单确认收货后，可提现收益'
					},
				]
				let config = {
					title: form.Config.title || '推手招募',
					welcome: form.Config.welcome || ('邀请你一起加入' + this.mallInfo.PcMallName),
					bgImage: form.Config.bgImage || '/image/pagemode-bg.png',
					mainTitle: form.Config.mainTitle,
					subtitle: form.Config.subtitle,
					lightColor: form.Config.lightColor || '#C0391F',
					darkColor: form.Config.darkColor || '#8C1E09',
					list: form.Config.list.map((v, i) => {
						// v.title = v.title||list[i].title
						// v.content = v.content||list[i].content
						return v
					}),
					customContent: form.Config.customContent || '',
				}
				form.DriverRecruitmentPageConfig = JSON.stringify(config)
				form.DriverRecruitmentPagePromoteProductJumpConfig = JSON.stringify(this.recommendBtnLink);
				form.DriverRecruitmentPageInviteFriendJumpConfig = JSON.stringify(this.invateFriendLink);
				let res = await malldriverRecruitmentConfigSave(form)
				if (res.IsSuccess) {
					this.$message.success('保存成功')
					this.getinfo()
				}
			},
			save(formName) {
				console.log(this.form)
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.submit()
					} else {
						this.$message.error('请完善推手招募配置')
						this.$nextTick(() => {
							const element = document.querySelectorAll('.el-form-item__error')[0]
							// 滚动到错误元素对应位置 
							element.scrollIntoView({
								behavior: 'smooth',
								block: 'center'
							})
						})
						return false;
					}
				});
			},
			toshoplist() {
				this.$router.push({
					path: '/goods/goodsList'
				})
			},
			torules() {
				this.$router.push({
					path: '/Customer/storedrule'
				})
			}
		}
	}
</script>

<style lang="less" scoped>
.ellipsis-one{
	max-width: 278px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	display: inline-block;
}
.flex {
	display: flex;
}

.flex-align-center {
	align-items: center;
}

.flex-column {
	flex-direction: column;
}

.grayfont-12 {
	color: #999999;
	line-height: 1.5;
	font-size: 12px;
}

.secgray-box {
	padding: 16px;
	background: rgb(251, 251, 251);
	display: inline-block;
}

.label-font {
	color: #606266;
	font-size: 14px;
	font-weight: bold;
	white-space: nowrap;
	flex-shrink: 0;
	width: 150px;
	text-align: right;
	padding-right: 12px;
}

.bottom-banner {
	position: fixed;
	bottom: 0;
	left: 230px;
	right: 0;
	height: 76px;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 2000;
	background: white;
}

@media screen and (max-width:1280px) {
	.bottom-banner {
		left: 150px
	}
}

.error-font-money {
	::v-deep .el-form-item__error {
		left: 25px;
	}
}
</style>

<style lang="less"></style>